import { type MouseEvent, type ReactElement } from 'react'
import { Menu, Switch } from '@mantine/core'
import { useTranslation } from '@front/model'
import { TButton } from '../buttons'

type Props = {
  includeArchived: boolean
  onChange: (value: boolean) => void
  tooltip: string
}

export const ArchivedResultsMenu = ({ includeArchived, onChange, tooltip }: Props): ReactElement => {
  const { t } = useTranslation()

  return (
    <Menu position='bottom-end' shadow='md' withinPortal>
      <Menu.Target>
        <TButton
          buttonType='icon-full'
          size='xs'
          icon='more_vert'
          variant={includeArchived ? 'gray' : 'ghost'}
          tooltip={tooltip}
          onClick={stopPropagation}
        />
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          closeMenuOnClick={false}
          rightSection={
            <Switch size='xs' checked={includeArchived} readOnly styles={{ root: { pointerEvents: 'none' } }} />
          }
          onClick={() => onChange(!includeArchived)}
        >
          {t('Include results from Trash')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

function stopPropagation(event: MouseEvent): void {
  event.stopPropagation()
}
